import { defaultColors } from './default';

export const theme = {
  bodyBackground: '#fff',
  defaultLinkColor: '#e8c893',
  top: {
    heading: defaultColors.primary3,
    text: defaultColors.primary3,
    play: defaultColors.primary3,
    imagePlaceholder: '#fff',
  },
  bottom: {
    heading: defaultColors.primary3,
    text: defaultColors.primary3,
  },
  tile: {
    default: {
      background: '#f3f3f3',
      backgroundHover: '#e8c893',
      active: '#e8c893',
      activeColor: defaultColors.primary3,
      color: defaultColors.primary3,
      colorHover: defaultColors.primary3,
    },
    viewing: {
      heading: defaultColors.primary3,
      text: defaultColors.primary3,
      time: defaultColors.primary3,
    },
    details: {
      county: defaultColors.primary3,
      address: defaultColors.primary3,
      price: defaultColors.primary3,
      common: defaultColors.primary3,
      facebook: defaultColors.primary3,
    },
    broker: {
      background: '#f3f3f3',
      title: '#999',
      link: defaultColors.primary3,
      mail: {
        fill: defaultColors.primary3,
        stroke: '#f3f3f3',
      },
    },
    button: {
      background: defaultColors.primary3,
      color: '#fff',
      backgroundHover: defaultColors.primary3,
      colorHover: '#fff',
    },
  },
  input: {
    font: {
      size: '1rem',
    },
    background: '#4b4b4b',
    color: 'rgb(255, 255, 255)',
    placeholder: '#b0b0b0',
    label: 'rgb(255, 255, 255)',
    labelAfter: 'rgb(100, 100, 100)',
    error: 'rgb(220, 40, 30)',
    padding: '15px',
  },
  buttons: {
    solid: {
      primary: {
        background: '#fff',
        color: defaultColors.primary3,
      },
      secondary: {
        color: '#e8c893',
        borderColor: '#e8c893',
      },
      tertiary: {
        color: '#e8c893',
        borderColor: '#e8c893',
      },
    },
    outline: {
      primary: {
        color: defaultColors.primary3,
        borderColor: defaultColors.primary3,
      },
    },
    underline: {
      primary: {},
      secondary: {},
      tertiary: {},
    },
  },
};
